import PropTypes from 'prop-types';
import { CurrencyInput as CurrencyInputBase } from '@figure/frontlib-gui';

/**
 * Wraps gui version of CurrencyInput to fix handling the onChange callback value.
 */
const CurrencyInput = ({ onChange, ...rest }) => (
  <CurrencyInputBase
    onChange={(value) => {
      let parsedValue = value;
      if (typeof value === 'string') parsedValue = value.length > 0 ? Number.parseInt(value, 10) : undefined;
      onChange(parsedValue);
    }}
    {...rest}
  />
);

CurrencyInput.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default CurrencyInput;
